import React from 'react';
import { Card, Circle, HStack, Text } from '@wegroup/design-system';
import { useSelf } from '../../../../../../../common/src/api/getSelf';
import { Bicycle } from '../../../../../../../parties/src/types/RiskObject';
import RiskObjectIconPicker from '../../../../../../../common/src/components/RiskObjectIconPicker';

interface Props {
  type: string;
  self: string;
}

const OffersOverviewRiskObjectBadge: React.FC<Props> = ({ type, self }) => {
  const { data } = useSelf<Bicycle>({ self, module: 'offers' });

  return (
    <Card boxShadow="none">
      <HStack spacing="3">
        <Circle bg="primary.50" color="primary.500" p="1">
          <RiskObjectIconPicker riskObject={type} />
        </Circle>
        <Text flexGrow={1}>{data?.name}</Text>
        <Text textStyle="normalBodyMedium">
          {data?.value ? `${data.value} €` : '-'}
        </Text>
      </HStack>
    </Card>
  );
};

export default OffersOverviewRiskObjectBadge;
